import { render, staticRenderFns } from "./SearchAutocomplete.component.vue?vue&type=template&id=4ebf69d5&scoped=true&lang=pug"
import script from "./SearchAutocomplete.component.vue?vue&type=script&lang=ts"
export * from "./SearchAutocomplete.component.vue?vue&type=script&lang=ts"
import style0 from "./SearchAutocomplete.component.vue?vue&type=style&index=0&id=4ebf69d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebf69d5",
  null
  
)

export default component.exports